/**
 * 쓰러짐 감지 오탐지/미탐지 피드백 카테고리 정의
 */

export const TUMBLE_FALSE_POSITIVE_CAUSES = {
  REST: {
    code: '휴식 중 작업자',
    description: '작업자가 의도적으로 쉬거나 누워 있는 상태',
    examples: ['점심시간 휴식', '잠깐 앉아 쉬는 중', '의도적으로 누운 자세'],
  },
  CROUCH: {
    code: '웅크린/굽힌 자세',
    description: '바닥 작업, 배관 점검 등 낮은 자세의 정상 작업',
    examples: ['바닥 배관 작업', '낮은 위치 점검', '무릎 꿇고 작업'],
  },
  SHADOW: {
    code: '그림자/음영',
    description: '조명이나 구조물에 의한 그림자 효과로 사람처럼 보임',
    examples: ['장비 그림자', '구조물 음영', '사람 형태의 그림자'],
  },
  EQUIPMENT: {
    code: '장비 옆 작업',
    description: '장비 뒤 또는 옆에서 작업하여 쓰러진 것처럼 보이는 경우',
    examples: ['장비 뒤쪽 작업', '낮은 기계 옆 위치', '장비와 겹친 자세'],
  },
  CAMERA_ANGLE: {
    code: '카메라 각도',
    description: '카메라 각도나 위치로 인해 정상 자세가 쓰러짐처럼 보이는 경우',
    examples: ['위에서 아래 촬영', '측면 각도 왜곡', '사각지대'],
  },
  OTHER: {
    code: '기타',
    description: '위 카테고리에 해당하지 않는 기타 원인',
    examples: ['미분류 원인'],
  },
} as const;

export const TUMBLE_FALSE_NEGATIVE_CAUSES = {
  // 1. 쓰러짐 유형 - 선택 (카메라 거리 등으로 확인 불가한 경우 '확인불가' 선택)
  FALL_TYPE: {
    required: false,
    label: '쓰러짐 유형 (확인 가능한 경우)',
    SUDDEN_FALL: {
      code: '급격한 낙상',
      description: '갑자기 쓰러지는 형태',
      examples: ['의식 잃음', '충격으로 쓰러짐', '갑자기 넘어짐'],
    },
    GRADUAL_COLLAPSE: {
      code: '점진적 쓰러짐',
      description: '천천히 주저앉거나 쓰러지는 형태',
      examples: ['무릎부터 주저앉음', '서서히 쓰러짐', '힘없이 내려앉음'],
    },
    SLIP_FALL: {
      code: '미끄러짐 낙상',
      description: '바닥이 미끄러워 낙상',
      examples: ['물기 있는 바닥', '기름 유출 구역', '미끄러운 슬로프'],
    },
    TRIP_FALL: {
      code: '걸려 넘어짐',
      description: '장애물에 걸려 넘어지는 형태',
      examples: ['케이블에 걸림', '장비에 걸려 넘어짐', '단차에 걸림'],
    },
    UNKNOWN: {
      code: '확인불가',
      description: '카메라 거리나 화질 문제로 쓰러짐 유형 확인 불가',
      examples: ['원거리 촬영', '광각 카메라', '낮은 해상도'],
    },
  },

  // 2. 감지 실패 주요 원인 - 필수
  DETECTION_FAILURE_CAUSE: {
    required: true,
    label: '감지 실패 주요 원인',
    WIDE_ANGLE_CAMERA: {
      code: '광각/원거리 카메라',
      description: '넓은 영역을 커버하는 광각 카메라로 작업자가 매우 작게 촬영됨',
      examples: ['현장 전체 조망 카메라', '광각 렌즈', '높은 위치 설치 카메라'],
    },
    CAMERA_DISTANCE: {
      code: '카메라 거리',
      description: '카메라와 거리가 멀어 작게 보여 감지 실패',
      examples: ['원거리 작업자', '넓은 현장 촬영', '화면에서 사람이 매우 작음'],
    },
    HIGH_ELEVATION_ANGLE: {
      code: '높은 설치 각도',
      description: '카메라가 높은 위치에서 내려다보는 각도로 쓰러진 자세 구별 어려움',
      examples: ['수직에 가까운 내려다봄', '탑뷰에 가까운 각도', '크레인/고층 설치'],
    },
    OBSTACLE: {
      code: '장애물/가려짐',
      description: '구조물이나 장비가 시야를 가려 감지 실패',
      examples: ['기둥에 가려짐', '장비 뒤에서 쓰러짐', '구조물 사각지대'],
    },
    LOW_VISIBILITY: {
      code: '낮은 가시성',
      description: '어두운 환경이나 역광으로 감지 어려움',
      examples: ['어두운 작업공간', '역광 상황', '야간 작업'],
    },
    VIDEO_QUALITY: {
      code: '화면 품질',
      description: '해상도, 밝기, 초점 문제로 감지 실패',
      examples: ['낮은 해상도', '초점 흐림', '압축 노이즈'],
    },
    SIMILAR_POSTURE: {
      code: '유사 자세 혼동',
      description: '쓰러짐과 유사한 작업 자세 때문에 필터링됨',
      examples: ['바닥 작업 자세', '웅크린 자세', '낮은 위치 유지'],
    },
    CROWD: {
      code: '주변 작업자 밀집',
      description: '다른 작업자들로 인해 쓰러진 사람이 가려짐',
      examples: ['여러 명 작업 중', '작업자들 사이에서 발생', '밀집 구역'],
    },
  },
};
